<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-content">
      <h2 mat-dialog-title>Edit Exercise Instructions</h2>
      <p class="dialog-subtitle">
        <mat-icon class="exercise-icon">fitness_center</mat-icon>
        <strong>{{ exercise.exerciseName }}</strong> for {{ memberName }}
      </p>
    </div>
    <button
      mat-icon-button
      class="close-button"
      (click)="onCancel()"
      title="Close dialog"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <!-- Instruction Input Fields -->
    <div
      class="instruction-list"
      cdkDropList
      (cdkDropListDropped)="onDrop($event)"
    >
      <div
        *ngFor="
          let item of customInstructionsList;
          let i = index;
          trackBy: trackByIndex
        "
        class="instruction-row"
        cdkDrag
      >
        <div class="drag-handle" cdkDragHandle>
          <mat-icon>drag_indicator</mat-icon>
        </div>
        <mat-form-field appearance="outline" class="instruction-field">
          <mat-label>{{ i + 1 }}</mat-label>
          <input
            matInput
            [(ngModel)]="customInstructionsList[i]"
            placeholder="Enter instruction..."
            maxlength="200"
          />
        </mat-form-field>
        <button
          mat-icon-button
          color="primary"
          (click)="addInstruction()"
          class="action-btn add-btn"
          [disabled]="customInstructionsList.length >= 10"
          title="Add instruction"
        >
          <mat-icon>add</mat-icon>
        </button>
        <button
          mat-icon-button
          color="warn"
          (click)="removeInstruction(i)"
          class="action-btn remove-btn"
          [disabled]="customInstructionsList.length <= 1"
          title="Remove instruction"
        >
          <mat-icon>remove</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button type="button" (click)="onCancel()" class="cancel-button">
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="onSave()"
      class="save-button"
    >
      <mat-icon>save</mat-icon>
      Save
    </button>
  </div>
</div>
